import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";
import SiteHeader from "@/components/common/SiteHeader";

const LL87VendorProfilePage = lazy(
  () => import("@/pages/Filings/LL87Submission/VendorProfile/Page"),
);

const LL87VendorProfileRoute = () => {
  const { vendorId } = Route.useParams();
  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader header="Energy Auditor Profile" />
      <Suspense fallback={null}>
        <LL87VendorProfilePage vendorId={vendorId} />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute("/vendors_/ll87_/$vendorId/")({
  component: LL87VendorProfileRoute,
});
